import { useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { useProjectContext } from "../contexts/ProjectContext";
import { useProjectContracts } from "@/hooks/useProjectContracts";
import FinancialPageHeader from "./components/FinancialPageHeader";
import SummarySection from "./components/SummarySection";
import ContractsList from "@/components/financial/contracts/ContractsList";
import CreateContractWizard from "./components/CreateContractWizard";

export default function FinancialContent({ projectId }: { projectId: string }) {
  const { project } = useProjectContext();
  const { isAdmin } = useAuth();
  const { contracts, loading: contractsLoading } = useProjectContracts(projectId);
  const [wizardOpen, setWizardOpen] = useState(false);

  if (!project.hasFinancialAccess && !isAdmin) {
    return <Navigate to={`/projects/${projectId}`} replace />;
  }

  return (
    <div className="space-y-8">
      <FinancialPageHeader
        showCreateButton={isAdmin}
        onNewContract={() => setWizardOpen(true)}
      />
      <SummarySection projectId={projectId} />
      <ContractsList
        contracts={contracts}
        projectId={projectId}
        loading={contractsLoading}
        showMembers={isAdmin}
        showAdminActions={isAdmin}
      />

      {isAdmin && (
        <CreateContractWizard
          project={project}
          isOpen={wizardOpen}
          onClose={() => setWizardOpen(false)}
        />
      )}
    </div>
  );
}
